import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import Gantt from 'frappe-gantt';

import { ScheduleDetailConstructionZone, ScheduleDetailTask } from '../types';

dayjs.extend(isSameOrAfter);
const now = dayjs().format('YYYY-MM-DD');

const generateTaskId = (id: number) => `gantt-task-${id}`;

const generateConstructionZoneId = (id: number) => `gantt-constructionZone-${id}`;

export const calculateForGanttForConstructionZone = (input: {
  constructionZone: ScheduleDetailConstructionZone;
}): Gantt.Task => {
  const { constructionZone } = input;
  let actual;
  //start endが存在し、startがendより後でない場合は値を返す
  const actualStartDate = constructionZone.total?.actualStartDate;
  const actualEndDate = constructionZone.completeDate || now;
  if (actualStartDate && actualEndDate && dayjs(actualEndDate).isSameOrAfter(actualStartDate)) {
    actual = {
      start: actualStartDate,
      end: actualEndDate,
    };
  }
  let delay;
  //start endが存在し、startがendより後でない場合は値を返す
  //scheduleEndDateとの衝突を防ぐために、1日後にしている
  const delayStartDate = dayjs(constructionZone.scheduledEndDate)
    .add(1, 'day')
    .format('YYYY-MM-DD');
  const delayEndDate = constructionZone.total?.estimatedCompleteDate;
  if (
    delayStartDate &&
    delayEndDate &&
    dayjs(delayEndDate).isSameOrAfter(delayStartDate) &&
    constructionZone.total?.delayDays > 0
  ) {
    delay = {
      start: delayStartDate,
      end: delayEndDate,
    };
  }

  const ganttTask: Gantt.Task = {
    id: generateConstructionZoneId(constructionZone.id),
    name: constructionZone.name,
    start: constructionZone.scheduledStartDate,
    end: constructionZone.scheduledEndDate,
    // progress: constructionZone.total?.progressRate || 0,
    progressRate: Number(constructionZone.total?.progressRate?.toFixed(1)) || 0,
    dependencies: '',
    actual,
    delay,
    isDelay: constructionZone.total ? constructionZone.total.delayDays > 0 : false,
    status: constructionZone.status,
    type: 'constructionZone',
    constructionZoneId: constructionZone.id,
  };
  return ganttTask;
};

export const calculateForGanttForTask = (input: {
  task: ScheduleDetailTask;

  constructionZone: ScheduleDetailConstructionZone;
}): Gantt.Task => {
  const { task, constructionZone } = input;
  const taskPosition = (() => {
    //親工区内で最もidが小さいタスクの場合はfirst・最もidが大きいタスクの場合はlast・それ以外はmiddle
    //WARN: ここでDeep Copyをしないと、constructionZone.tasksの順番が変わってしまう
    //https://zenn.dev/yuutakkuma/articles/11aefd7973f2b4
    const constructionZoneTasks: ScheduleDetailTask[] = JSON.parse(
      JSON.stringify(constructionZone.tasks)
    );

    const firstTask = constructionZoneTasks[0];
    const lastTask = constructionZoneTasks[constructionZoneTasks.length - 1];

    if (task.id === firstTask.id) return 'first';
    if (task.id === lastTask.id) return 'last';
    return 'middle';
  })();
  let actual;
  //start endが存在し、startがendより後でない場合は値を返す
  const actualStartDate = task.total?.actualStartDate;
  const actualEndDate = task.completeDate || now;
  if (actualStartDate && actualEndDate && dayjs(actualEndDate).isSameOrAfter(actualStartDate)) {
    actual = {
      start: actualStartDate,
      end: actualEndDate,
    };
  }
  let delay;
  //start endが存在し、startがendより後でない場合は値を返す
  //scheduleEndDateとの衝突を防ぐために、1日後にしている
  const delayStartDate = dayjs(task.scheduledEndDate).add(1, 'day').format('YYYY-MM-DD');
  const delayEndDate = task.total?.estimatedCompleteDate;
  if (
    delayStartDate &&
    delayEndDate &&
    dayjs(delayEndDate).isSameOrAfter(delayStartDate) &&
    task.total?.delayDays > 0
  ) {
    delay = {
      start: delayStartDate,
      end: delayEndDate,
    };
  }
  const ganttTask: Gantt.Task = {
    id: generateTaskId(task.id),

    name: task.name,
    start: task.scheduledStartDate,
    end: task.scheduledEndDate,
    //progress: task.total?.progressRate || 0,
    dependencies: task.beforeTaskId ? generateTaskId(task.beforeTaskId) : '',
    actual,
    delay,
    progressRate: Number(task.total?.progressRate?.toFixed(1)) || 0,
    isDelay: task.total ? task.total.delayDays > 0 : false,
    status: task.status,
    type: 'task',
    constructionZoneId: constructionZone.id,
    taskId: task.id,
    taskPosition,
  };
  return ganttTask;
};
